const UserInfoItem = ({ title, titleSuffix, subTitle, className = "" }) => {
  const width = 130;
  return (
    <div className="user-info">
      <span className="tb-lead fw-bold d-flex" title={title}>
        <span
          className={`d-inline-block ellipsis ${className}`}
          style={{ width: titleSuffix ? 110 : width }}
        >
          {title}
        </span>
        {titleSuffix && titleSuffix}
      </span>
      {subTitle && (
        <span
          className="d-block ellipsis"
          style={{ width }}
          dir="auto"
          title={subTitle}
        >
          {subTitle}
        </span>
      )}
    </div>
  );
};

export default UserInfoItem;
